import { useAuth } from "contexts/AuthContext";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppstoreOutlined, MenuOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TOP_NAV, BOTTOM_NAV } from "../../nav/navData";
import paths from "../../nav/paths";

const NAV_ICONS = {
  home:           "home",
  dashboard:      "chart-line",
  projects:       "folder-tree",
  incidents:      "exclamation-triangle",
  tickets:        "ticket-alt",
  "troubleshooting-guides": "book-open",
  docs:           "file-alt",
  "chat-space":   "comments",
  "email-messages": "envelope",
  "access-control": "shield-alt",
  workspaces:      "th-large",
  partners:        "handshake",
  users:          "users",
  tags:           "tags",
  "qa-test-runs": "vial-circle-check",
  settings:       "cog",
  feedback:       "comment",
  help:           "question-circle",
  support:        "headset",
};

export default function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const isAct = (to) => pathname === to || (to !== "/" && pathname.startsWith(`${to}/`));

  const iconNode = (item) => (
    <span className="pm-ni-ico">
      {item.id === "workspaces" ? (
        <AppstoreOutlined />
      ) : (
        <FontAwesomeIcon icon={NAV_ICONS[item.id]} />
      )}
    </span>
  );

  const renderNavItem = (item) => (
    <div
      key={item.id}
      className={`pm-ni${isAct(item.to) ? " act" : ""}`}
      onClick={() => navigate(item.to)}
    >
      {iconNode(item)}
      <span className="pm-ni-lbl">{item.label}</span>
      {item.badge && <span className="pm-badge">{item.badge}</span>}
      <span className="pm-tip">{item.label}</span>
    </div>
  );

  return (
    <aside
      className={`pm-sb${collapsed ? " col" : ""}`}
      style={{
        flex:     collapsed ? "0 0 44px" : "0 0 256px",
        width:    collapsed ? 44 : 256,
        minWidth: collapsed ? 44 : 256,
        maxWidth: collapsed ? 44 : 256,
      }}
    >
      <div className="pm-sb-head">
        <button
          type="button"
          className="pm-logo-wrap"
          onClick={() => navigate(paths.pmDashboard)}
          aria-label="Go to home"
        >
          <img src="/logo1.png" alt="Project Manager" className="pm-logo-img" />
        </button>
        <button
          type="button"
          className="pm-sb-toggle"
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <MenuOutlined />
        </button>
      </div>

      <nav className="pm-nav">
        {TOP_NAV.map(renderNavItem)}

        <div className="pm-nav-divider" />

        {BOTTOM_NAV.map(renderNavItem)}
      </nav>

      <div className="pm-sb-foot">
        <div className="pm-foot-title">Account</div>
        <div
          className="pm-foot-ni pm-foot-danger"
          onClick={() => logout(false, "/login")}
        >
          <span style={{ fontSize: 14 }}>
            <FontAwesomeIcon icon="right-from-bracket" />
          </span>
          <span className="pm-foot-text">Sign out</span>
        </div>
      </div>
    </aside>
  );
}
